<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.users.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="remove()"
                style="float:right">
        {{ $t('common.Remove') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-6">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Email') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="email" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Username') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="userName" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Color') }}:</label>
          </div>
          <div class="col-lg-9">
            <ColorInput
              :editable="false"
              v-model="color" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('entities.Roles.Singular') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="role.name" />
          </div>
        </div>
        <div class="row my-3"
             v-if="role != null && (role.name === 'Lékař' || role.name === 'Doctor')">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.IsMainDoctor') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-checkbox
              :disabled="true"
              v-model="mainDoctor" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ColorInput from '@components/input/ColorInput';

export default {
  name: 'UserViewDetail',
  components: {
    ColorInput
  },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewUser', ['email', 'userName', 'color', 'role', 'mainDoctor']),
  },
  created() {
    this.fetchUser(this.id)
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchUser: 'viewUser/fetchUser' }),
    async remove() {
      this.$bvModal.msgBoxConfirm(this.$t('ViewUser.RemoveMessage', { 1: this.id }), {
        title: this.$t('ViewUser.ModalTitle'),
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Remove',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true
      })
        .then(async (value) => {
          if (value) {
            await this.axios.delete('/admin/users/delete', {
              params: {
                Id: this.id
              }
            }).then(async (res) => {
              if (res.status === 204) {
                this.$root.$bvToast.toast(this.$t('ViewUser.SuccessToast.Body'), {
                  title: this.$t('ViewUser.SuccessToast.Title'),
                  variant: 'success',
                  toaster: 'b-toaster-top-right'
                });
                this.$router.push({ name: 'admin.users.view' });
              }
            });
          }
        })
        .catch(() => {
          this.$root.$bvToast.toast(this.$t('ViewUser.FailureToast.Body'), {
            title: this.$t('ViewUser.FailureToast.Title'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
        });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
